/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-filename-extension */
import "react-app-polyfill/stable";
import "unorm";
import React from "react";
import { createRoot } from "react-dom/client";
import values from "object.values";
import AppWrapper from "./App";

values.shim();

// React 18 rendering method
const container = document.getElementById("root");
const root = createRoot(container);
root.render(<AppWrapper />);
